module.exports = "/images/Default.png?cbe67864be02c62ec600344d38b7a164";